import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { FieldLayout } from "@/pages/ContactsPage/Components/FieldLayout";
import {
  FillTheFieldErrorMessage,
  FormInput,
  FormTextArea,
  FormYearDatePicker,
} from "@/shared/Components";
import styles from "./styles.module.scss";

type Props = {
  index: number;
  onBlur?: () => void;
  onChange?: () => void;
};

export const EducationField = ({ index, onBlur, onChange }: Props) => {
  const { t } = useTranslation();

  const handleBlur = useCallback(() => {
    onBlur?.();
    onChange?.();
  }, [onBlur]);

  return (
    <FieldLayout>
      <FillTheFieldErrorMessage name={`educations.${index}`} />
      <FormInput
        name={`educations.${index}.place`}
        placeholder={t("contactsPage.activities.school")}
        onBlur={handleBlur}
      />
      <FormInput
        name={`educations.${index}.major`}
        placeholder={t("contactsPage.activities.major")}
        onBlur={handleBlur}
      />
      <div className={styles.dates}>
        <FormYearDatePicker
          placeholder={t("common.dateFrom")}
          name={`educations.${index}.educationStart`}
          customOnChange={handleBlur}
        />
        <FormYearDatePicker
          placeholder={t("common.dateTo")}
          name={`educations.${index}.educationEnd`}
          customOnChange={handleBlur}
        />
      </div>
      <FormTextArea
        name={`educations.${index}.additional`}
        placeholder={t("common.about")}
        onBlur={handleBlur}
        customOnChange={onChange}
      />
    </FieldLayout>
  );
};
